export enum ComboAllType {
    All = 1,
    NoneOfThem = 2,
    None = 3,
    MixedAll = 4,
    MixedNone = 5,
    NullAll = 6,
    NullNoneOfThem = 7,
    NullNone = 8,
    NullMixedAll = 9,
    NullMixedNone = 10,
}